import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DistributionsService } from 'src/app/services/distributions.service';

import { firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-material-components-list',
  templateUrl: './material-components-list.component.html',
  styleUrls: ['./material-components-list.component.scss']
})
export class MaterialComponentsListComponent implements OnInit {
  // #region Variables
  /** Estado original de los insumos al abrir el diálogo. */
  private current: Array<{ id: number, name: string, qty: number }> = [];
  /** Todos los insumos disponibles. */
  allcomponents: Array<{ id: number, name: string }> = [];
  /** Las columnas de la tabla. */
  columns: Array<string> = ['component', 'quantity', 'actions'];
  /** `true` si la información está cargando. */
  loading: boolean = true;
  /** Insumos asignados al material. */
  matcomponents: Array<{ id: number, name: string, qty: number }> = [];
  /** Insumo seleccionado en el dropdown. */
  selected: number = -1;


  constructor(@Inject(MAT_DIALOG_DATA) public data: { components: string, material: { id: number, name: string }}, private distributions: DistributionsService, private dref: MatDialogRef<MaterialComponentsListComponent>) {}
  
  ngOnInit(): void {
    this.loadData();
  }


  // #region Getters/Setters
  /** `true` si la lista actual es diferente a la lista original. */
  get modified(): boolean {
    return JSON.stringify(this.matcomponents) !== JSON.stringify(this.current);
  }

  /** `true` si todos los insumos tienen datos válidos para guardar. */
  get valid(): boolean {
    return this.matcomponents.every(x => Number.isInteger(x.qty) && x.qty >= 1 );
  }


  // #region Functions
  /** Agrega el insumo seleccionado a la lista de insumos del material. */
  addComponent(): void {
    if (this.selected === -1) return;

    // Evitar duplicados
    const component = this.allcomponents[this.selected];

    if (this.matcomponents.some(x => x.id === component.id)) return;

    this.matcomponents = [
      ...this.matcomponents,
      {
        id: component.id,
        name: component.name,
        qty: 1
      }
    ];

    this.selected = -1;
  }

  /** Cierra el *dialog* e indica si el componente debe recargar su información.
    * @param {boolean} reload - `true` si el componente padre debe recargar la información. */
  close(reload: boolean): void {
    this.dref.close(reload);
  }

  /** Borra un insumo de la lista de insumos de acuerdo con su índice.
    * @param {number} x - El índice del insumo por quitar. */
  removeComponent(x: number): void {
    this.matcomponents = this.matcomponents.filter((_, i) => i !== x);
  }


  // #region Asyncs
  /** Trae la lista de insumos disponibles y los insumos asociados con el material. @async */
  async loadData(): Promise<void> {
    const compdata = await firstValueFrom(this.distributions.getMatComponents());
    this.allcomponents = compdata.components.sort((a, b) => a.name.localeCompare(b.name));
    this.matcomponents = JSON.parse(this.data.components);
    this.current = structuredClone(this.matcomponents);
    this.loading = false;
  }

  /** Guarda la lista de insumos. @async */
  async setData(): Promise<void> {
    Swal.fire({
      allowEscapeKey: false,
      allowOutsideClick: false,
      icon: 'info',
      title: 'Guardando...',
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      await firstValueFrom(this.distributions.saveMatComponents({ components: this.matcomponents, mat_id: this.data.material.id }));
      
      await Swal.fire({
        icon: 'success',
        title: '¡Listo!',
        text: 'Se guardaron los insumos para este material.',
        confirmButtonText: 'OK'
      });

      this.close(true);
    } catch (error) {
      console.error('Error saving material components:', error);

      await Swal.fire({
        icon: 'error',
        title: 'Algo salió mal',
        text: 'Por favor, inténtalo más tarde.',
        confirmButtonText: 'OK'
      });
    }
  }
}